import gql from 'graphql-tag';

export const updateTextSetting = gql`
  mutation UpdateTextSetting($enabled: Boolean!) {
    updateTextSetting(enabled: $enabled) {
      success
    }
  }
`;

export const updateEmailMutation = gql`
  mutation UpdateEmail($email: String!, $password: String!) {
    updateEmail(email: $email, password: $password) {
      success
    }
  }
`;

export const updateEmailV2Mutation = gql`
  mutation UpdateEmailV2($email: String!) {
    updateEmailV2(email: $email) {
      success
    }
  }
`;

export const updateProfile = gql`
  mutation UpdateProfile($profile: consumerUserProfileInput!) {
    updateProfileV2(profile: $profile) {
      success
    }
  }
`;

export const updateConsumerUser = gql`
  mutation UpdateConsumerUser($input: consumerUserProfileInput!) {
    updateConsumerUser(user: $input) {
      success
    }
  }
`;

export const sendVerificationTokenMutation = gql`
  mutation SendVerificationToken($redirectUrl: String!, $dispensaryId: String) {
    sendVerificationToken(redirectUrl: $redirectUrl, dispensaryId: $dispensaryId) {
      success
    }
  }
`;

export const validateVerificationTokenMutation = gql`
  mutation ValidateVerificationToken($token: String!) {
    validateVerificationToken(token: $token) {
      success
    }
  }
`;

export const acceptTermsOfService = gql`
  mutation AcceptTermsOfService {
    acceptTermsOfService {
      success
    }
  }
`;

export const setViewedTermsOfService = gql`
  mutation SetViewedTermsOfService {
    setViewedTermsOfService {
      success
    }
  }
`;
